import { render, staticRenderFns } from "./distributionLoadApp.vue?vue&type=template&id=546256a0&scoped=true"
var script = {}
import style0 from "./distributionLoadApp.vue?vue&type=style&index=0&id=546256a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546256a0",
  null
  
)

export default component.exports